import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { AuthService, NotificationService } from 'src/app/shared/services';
import { LuxNotification } from '../../interfaces';
import { catchError, of, pipe } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-notifications-popover',
  imports: [PopoverModule, ButtonModule, FormsModule, MessageModule, CommonModule, DividerModule, SelectButtonModule],
  templateUrl: './notifications-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsPopoverComponent {

private notService = inject(NotificationService);
private authService = inject(AuthService);

public isLoading = signal<boolean>(true);

public user = computed(() => this.authService.currentUser() );

stateOptions: any[] = [{ label: 'Pedientes', value: 'unread' },{ label: 'Leídas', value: 'read' }];
value: string = 'unread';

public role:string;

public unreadNotifications:LuxNotification[] = [];
public readNotifications:LuxNotification[] = [];

ngOnInit() {
  this.notService.retrieveNotifications(this.user()!.uid)
  .pipe(
    catchError(() => of([]))
  )
  .subscribe(
    res => {
      const nots =  res;
      console.log(typeof res);
      console.log(res)
      this.unreadNotifications = nots.filter(n => !n.isAttended);
      this.readNotifications = nots.filter(n => n.isAttended);
      console.log(this.readNotifications);
      this.isLoading.set(false);
    }
  );
}

async markNotificationsAsRead() {
  console.log('Borrando')
  setTimeout(() => {  
    this.notService.markNotificationAsRead(this.unreadNotifications);  
  }, 2000);
}

 }
